var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitterIcon = function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.167 2.403c-.674.295-1.4.493-2.16.583A3.72 3.72 0 0 0 18.661.937a7.608 7.608 0 0 1-2.389.899 3.783 3.783 0 0 0-2.745-1.17c-2.429 0-4.213 2.23-3.665 4.546A10.735 10.735 0 0 1 2.11 1.344a3.673 3.673 0 0 0 1.164 4.944 3.79 3.79 0 0 1-1.703-.464C1.53 7.54 2.78 9.144 4.588 9.502c-.53.14-1.11.174-1.7.063a3.757 3.757 0 0 0 3.515 2.57A7.649 7.649 0 0 1 .834 13.67 10.77 10.77 0 0 0 6.6 15.333c6.983 0 10.929-5.806 10.69-11.013a7.59 7.59 0 0 0 1.877-1.917Z",
    fill: "#000"
  })));
};

export default SvgTwitterIcon;